import styled from "styled-components";

export const Header = styled.div`
  background-color: ${({ theme }) => theme.colors.dataViz.headerBgColor};
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1000;
  height: fit-content;
  width: 100%;
  border-radius: 0 0 10px 10px;
  padding-bottom: 5px;
`;

export const HeaderBox = styled.div`
  display: flex;
  padding: 7px 25px;
  border-right: 1px solid ${({ theme }) => theme.colors.dataViz.headerBorderColor};
  max-width: ${({ maxWidth }) => maxWidth};
  &:first-child {
    gap: 18px;
  }
  &:last-child {
    border-right: none;
    flex: 1 1 auto;
  }
  height: 78px;
`;
